/* eslint-disable max-len */
import React from 'react';
function Documents() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M9.2,6l2,2H20v10H4V6H9.2 M10,4H4C2.9,4,2,4.9,2,6l0,12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8c0-1.1-0.9-2-2-2h-8L10,4z" })));
}
export default Documents;
